(function () {
  Flint.file('mframework/views/facebookPhotoChooser.js', function (require) {
    Flint.staticStyles('FacebookPhotoChooser', {
      '$noPhoto': '#_flintapp noPhoto.FacebookPhotoChooser, #_flintapp .FacebookPhotoChooser.noPhoto, #_flintapp .ViewFacebookPhotoChooser.noPhoto, #_flintapp .FacebookPhotoChooser > .noPhoto',
      '$actionRow': '#_flintapp actionRow.FacebookPhotoChooser, #_flintapp .FacebookPhotoChooser.actionRow, #_flintapp .ViewFacebookPhotoChooser.actionRow, #_flintapp .FacebookPhotoChooser > .actionRow',
      '$topRow': '#_flintapp topRow.FacebookPhotoChooser, #_flintapp .FacebookPhotoChooser.topRow, #_flintapp .ViewFacebookPhotoChooser.topRow, #_flintapp .FacebookPhotoChooser > .topRow',
      '$tip': '#_flintapp tip.FacebookPhotoChooser, #_flintapp .FacebookPhotoChooser.tip, #_flintapp .ViewFacebookPhotoChooser.tip, #_flintapp .FacebookPhotoChooser > .tip',
      '$cancelModal': '#_flintapp cancelModal.FacebookPhotoChooser, #_flintapp .FacebookPhotoChooser.cancelModal, #_flintapp .ViewFacebookPhotoChooser.cancelModal, #_flintapp .FacebookPhotoChooser > .cancelModal'
    }, {
      '$noPhoto': {
        cursor: 'pointer',

        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        border: '1px dashed #ccc'
      },
      '$actionRow': {
        flexDirection: 'row'
      },
      '$topRow': {
        flexDirection: 'row',
        alignSelf: 'stretch',
        alignItems: 'stretch',
        alignContent: 'stretch',
        paddingBottom: 20,
        borderBottom: '1px solid #eee',
        marginBottom: 20
      },
      '$tip': {
        flexGrow: 1
      },
      '$cancelModal': {
        alignSelf: 'flex-end'
      }
    });
    Flint.view('FacebookPhotoChooser', function (view, on, $) {
      var pro = initPro(view, {
        width: M.defaultAtom(300),
        height: M.defaultAtom(168),
        circle: M.defaultAtom(false),
        children: atom(),
        style: M.mergeAtom({}),
        noPicStyle: M.mapAtom({})
      });

      var showingFbPhotos = atom(false);
      var selectedPhoto = M.mapAtom(null);

      selectedPhoto.react(function (selectedPhoto) {
        if (view.props.onSelect) {
          view.props.onSelect({ photo: selectedPhoto.toJS() });
        }
      }, { skipFirst: true });

      var showFbPhotos = function showFbPhotos() {
        FB.login(function (response) {
          if (response.authResponse && response.authResponse.grantedScopes.split(',').indexOf('user_photos') >= 0) {
            showingFbPhotos.set(true);
            M.mixpanel.track("FacebookPhotoChooserView");
          } else {
            M.mixpanel.track("FacebookPhotoChooserPermissionDenied");
          }
        }, {
          scope: 'user_photos',
          auth_type: 'rerequest',
          return_scopes: true
        });
      };view.render(function () {
        return Flint.iff(selectedPhoto.get()) && view.el(
          ['selectedPhoto', 1],
          { if: selectedPhoto.get() },
          view.el(['FacebookPhotoImage', 1], { photo: selectedPhoto.get(),
            width: pro.width.get(),
            height: pro.height.get(),
            style: pro.style.get()
          }),
          view.el(
            ['actionRow', 1],
            null,
            view.el(['EditLink', 1], { onClick: showFbPhotos }),
            view.el(['DeleteButton', 1], { onClick: function () {
                return selectedPhoto.set(null);
              } })
          )
        );
      });view.render(function () {
        return Flint.iff(!selectedPhoto.get()) && view.el(
          ['noPhoto', 1],
          { if: !selectedPhoto.get(),
            style: IMap({
              borderRadius: pro.circle.get() ? '50%' : 8
            }).merge(pro.noPicStyle.get()).toJS(),
            onClick: showFbPhotos
          },
          pro.children.get()
        );
      });view.render(function () {
        return Flint.iff(showingFbPhotos.get()) && view.el(
          ['MModal', 1],
          { if: showingFbPhotos.get(),
            onRequestClose: function () {
              showingFbPhotos.set(false);
              M.mixpanel.track("FacebookPhotoChooserCancel");
            },
            contentStyle: {
              margin: 50,
              flexGrow: 1,
              border: '1px solid #ccc',
              orderRadius: 8
            },
            overlayStyle: {
              alignItems: 'stretch',
              justifyContent: 'stretch',
              background: 'white'
            }
          },
          view.el(
            ['topRow', 1],
            null,
            view.el(
              ['tip', 1],
              null,
              'Choose a Facebook photo.'
            ),
            view.el(['CancelLink', 1], { className: 'cancelModal',
              onClick: function () {
                showingFbPhotos.set(false);
                M.mixpanel.track("FacebookPhotoChooserCancel");
              }
            })
          ),
          view.el(['FacebookPhotos', 1], { onSelect: function (_ref) {
              var photo = _ref.photo;

              selectedPhoto.set(photo);
              showingFbPhotos.set(false);
              M.mixpanel.track("FacebookPhotoChooserSelect");
            } })
        );
      });

      '7959bd9a';

      $["noPhoto"] = function (_, _index) {
        return { width: pro.width.get(),
          height: pro.height.get() };
      };

      '621ae1a2';
      'c3851ca8';
      '69c68a31';
      '0458ce7f';
    });
  })
})();
//# sourceMappingURL=facebookPhotoChooser.js.map
